<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-select
              v-model="selectedArea"
              :loading="loadingAreas"
              :placeholder="$t('message.please_select') + $t('attributes.area')"
              @input="onSelectArea"
            >
              <option value="" disabled>
                {{ $t('message.please_select') + $t('attributes.area') }}
              </option>
              <option
                v-for="option in areas"
                :value="option"
                :key="option.code"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field>
            <b-select
              v-model="selectedCatalog"
              :loading="loadingAreas"
              :disabled="catalogs.length <= 0"
              :placeholder="
                $t('message.please_select') + $t('attributes.catalog')
              "
              @input="onSelectCatalog"
            >
              <option value="">全部類別</option>
              <option
                v-for="option in catalogs"
                :value="option"
                :key="option.catalog_no"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>

          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.activation_status') }}
              </span>
            </p>
            <b-select v-model="filterStatus">
              <option value="">{{ $t('attributes.all') }}</option>
              <option value="true">{{ $t('attributes.shelve_on') }}</option>
              <option value="false">{{ $t('attributes.shelve_off') }}</option>
            </b-select>
          </b-field>

          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.travel_group_type') }}
              </span>
            </p>
            <b-select v-model="filterType">
              <option value="">{{ $t('attributes.all') }}</option>
              <option
                v-for="(type, idx) in groupTypes"
                :key="idx"
                :value="type.value"
              >
                {{ type.name }}
              </option>
            </b-select>
          </b-field>
          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.is_promote') }}
              </span>
            </p>
            <b-select v-model="isHome">
              <option value="">{{ $t('attributes.all') }}</option>
              <option value="true">{{ $t('attributes.yes') }}</option>
              <option value="false">{{ $t('attributes.no') }}</option>
            </b-select>
          </b-field>

          <b-field>
            <b-select v-model="showExpired">
              <option value="true">
                {{ $t('attributes.display_expired') }}
              </option>
              <option value="false">
                {{ $t('attributes.not_display_expired') }}
              </option>
            </b-select>
          </b-field>

          <b-field>
            <b-datepicker
              :placeholder="
                $t('message.please_select') + $t('attributes.departure_date')
              "
              v-model="selectedDates"
              range
              @input="onSelectedDates"
            >
              <button class="button is-danger" @click="onClearDates">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>

          <b-field>
            <b-input
              v-model="searchCode"
              :placeholder="
                $t('attributes.search') + $t('attributes.group_code')
              "
              type="search"
              icon="magnify"
            ></b-input>
          </b-field>
          <b-field>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
            ></b-input>
          </b-field>
        </b-field>
      </div>

      <div class="column is-1">
        <div class="buttons is-right">
          <b-button :loading="sending" class="is-primary" @click="onSearch">
            {{ $t('attributes.search') }}
          </b-button>
        </div>
      </div>
    </nav>

    <div v-for="item in items" :key="item.code">
      <travel-group-advance-form
        :travel-group="item"
        :situation-types="situationTypes"
        @updated="onUpdated"
      />
    </div>

    <b-loading :active="isLoading" is-full-page :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import { AREA_API, TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import TravelGroupAdvanceForm from '@/components/travel_groups/AdvanceForm'

export default {
  name: 'TravelGroupAdvanceList',
  components: {
    TravelGroupAdvanceForm
  },

  data() {
    const { query } = this.$route
    let startDate = null
    let endDate = null
    let selectedDates = []

    const groupTypes = this.GetTravelGroupTypes()

    if (query.start && query.end) {
      startDate = this.$dayjs.unix(query.start).toDate()
      endDate = this.$dayjs.unix(query.end).toDate()
      selectedDates = [startDate, endDate]
    }

    return {
      groupTypes,
      loading: false,
      loadingItems: false,
      total: 0,
      items: [],
      selectedItem: null,

      filterType: query.type || '',
      filterStatus: query.status || '',
      searchCode: query.code || '',
      searchName: query.search || '',
      sortField: query.sort || 'code',
      sortOrder: query.order || 'asc',
      defaultSortOrder: 'asc',
      page: query.page || 1,
      perPage: query.page_size || 50,
      showExpired: query.exp || false,
      isHome: query.is_home || '',

      loadingAreas: false,
      areas: [],
      catalogs: [],
      selectedArea: null,
      selectedAreaCode: query.ac || null,
      selectedCatalog: null,
      selectedCatalogNo: query.cn || null,

      situationTypes: [],

      selectedDates,
      startDate,
      endDate,

      isCreateModalActive: false,
      sending: false,

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  computed: {
    isLoading() {
      return this.loadingItems
    }
  },
  mounted() {
    this.loadAreas()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.getQuery(to.query)
      this.loadDate()
    }

    next()
  },
  methods: {
    async loadDate() {
      if (!this.selectedAreaCode) {
        return
      }

      this.loading = true
      await this.loadSituationTypes(this.selectedAreaCode)
      await this.loadTravelGroups()
      this.loading = false
    },
    async loadAreas() {
      await this.loadAreasAsync()

      if (this.selectedAreaCode) {
        await this.loadDate()
      }
    },
    async loadAreasAsync() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.catalogs = []
        this.selectedArea = null
        this.selectedCatalog = null

        if (this.selectedAreaCode) {
          this.selectedArea = areas.find(a => a.code === this.selectedAreaCode)
          this.catalogs = this.selectedArea
            ? this.selectedArea.catalogs.sort(c => c.sort)
            : []
        }
        if (this.selectedCatalogNo) {
          this.selectedCatalog = this.catalogs.find(
            c => c.catalog_no === this.selectedCatalogNo
          )
        }
      } catch (e) {
        this.areas = []
        this.catalogs = []
        this.selectedArea = null
        this.selectedAreaCode = null
        this.selectedCatalog = null
        this.selectedCatalogNo = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    async loadSituationTypes(areaCode) {
      try {
        this.$emit('update:loading', true)

        const res = await this.axios.get(`${AREA_API}/${areaCode}/events`)
        this.situationTypes = res.data.data
      } catch (e) {
        this.situationTypes = []

        notifyService.fetch_error('travel_group', e)
      } finally {
        this.$emit('update:loading', false)
      }
    },
    async loadTravelGroups() {
      try {
        const api = TRAVEL_GROUPS_API

        const params = {
          is_collaborate: false,
          area_code: this.selectedAreaCode,
          catalog_no: this.selectedCatalogNo,
          type: this.filterType,
          active: this.filterStatus && this.filterStatus === 'true',
          start_date: this.startDate,
          end_date: this.endDate,
          show_expired: this.showExpired,
          is_home: this.isHome,
          search_code: this.searchCode,
          search: this.searchName,
          sort_by: this.sortField,
          by_descending: this.sortOrder !== 'asc',
          page_size: this.perPage,
          page_number: this.page
        }

        this.loadingItems = true
        const res = await this.axios.get(api, { params })
        const data = res.data.data

        this.items = data.items
        this.total = data.item_count
      } catch (e) {
        this.items = []
        this.total = 0

        notifyService.fetch_error('travel_group', e)
      } finally {
        this.loadingItems = false
      }
    },
    getQuery(query) {
      this.filterType = query.type || ''
      this.filterStatus = query.status || ''
      this.searchCode = query.code || ''
      this.searchName = query.search || ''
      this.sortField = query.sort || 'code'
      this.sortOrder = query.order || 'asc'
      this.page = query.page || 1
      this.perPage = query.page_size || 50
      this.showExpired = query.exp || false
      this.isHome = query.is_home || ''

      if (query.start && query.end) {
        this.startDate = this.$dayjs.unix(query.start).toDate()
        this.endDate = this.$dayjs.unix(query.end).toDate()
        this.selectedDates = [this.startDate, this.endDate]
      } else {
        this.startDate = null
        this.endDate = null
        this.selectedDates = []
      }

      this.selectedArea = null
      this.selectedCatalog = null
      this.selectedAreaCode = query.ac || null
      this.selectedCatalogNo = query.cn || null

      if (this.selectedAreaCode) {
        this.selectedArea = this.areas.find(
          a => a.code === this.selectedAreaCode
        )
        this.catalogs = this.selectedArea
          ? this.selectedArea.catalogs.sort(c => c.sort)
          : []
      }
      if (this.selectedCatalogNo) {
        this.selectedCatalog = this.catalogs.find(
          c => c.catalog_no === this.selectedCatalogNo
        )
      }
    },
    updateQuery() {
      const query = {
        type: this.filterType,
        status: this.filterStatus,
        exp: this.showExpired,
        ac: this.selectedAreaCode,
        cn: this.selectedCatalogNo,
        code: this.searchCode,
        search: this.searchName,
        sort: this.sortField,
        order: this.sortOrder,
        is_home: this.isHome,
        page_size: this.perPage,
        page: this.page,
        start: this.startDate && this.$dayjs(this.startDate).unix(),
        end: this.endDate && this.$dayjs(this.endDate).unix()
      }

      Object.keys(query).forEach(key => !query[key] && delete query[key])

      this.$router
        .push({
          name: this.$route.name,
          query: query
        })
        .catch(() => {})
    },

    onSelectArea(option) {
      this.selectedArea = option
      this.selectedAreaCode = option ? option.code : null
      this.catalogs = option ? option.catalogs.sort(c => c.sort) : []
      this.selectedCatalog = null
      this.selectedCatalogNo = null
    },
    onSelectCatalog(option) {
      this.selectedCatalog = option
      this.selectedCatalogNo = option ? option.catalog_no : null
    },
    onSelectedDates() {
      this.startDate = this.selectedDates[0]
      this.endDate = this.selectedDates[1]
    },
    onClearDates() {
      this.selectedDates = null
      this.startDate = null
      this.endDate = null
    },

    onSearch() {
      if (!this.selectedAreaCode) {
        notifyService.error('請選擇線別！')
        return
      }

      this.page = 1
      this.updateQuery()
    },
    onPageChange(page) {
      this.page = page
      this.updateQuery()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.updateQuery()
    },
    onUpdated(group) {
      this.items = this.items.map(g => {
        if (g.code === group.code) {
          return group
        } else {
          return g
        }
      })
      this.selectedItem = group
    }
  }
}
</script>

<style lang="scss" scoped>
.datepicker {
  .datepicker-table {
    .datepicker-cell {
      padding: 0.6rem 0.65rem;
    }
  }
}
</style>
